module.exports = __webpack_public_path__ + "static/media/west-blvd-aerial.3eb3171c.jpg";